import { useAuthenticatedApi } from '@transport-insights/uikit';
import { useConfig } from '@src/context/config';

export default () => {
  const { REGULATORY_REPORTING_API_URL } = useConfig();
  const api = useAuthenticatedApi(REGULATORY_REPORTING_API_URL);

  return {
    async getReportData(reportName, rcaId, lockYear) {
      if (!lockYear) return {};
      const encodedLockYear = lockYear.replace('/', '-');
      const url = `/report/${reportName}/${rcaId}/${encodedLockYear}`;

      const res = await api.get(url);
      return res?.data || {};
    },
    async downloadReport(reportName, rcaId, lockYear, format = 'csv') {
      if (!lockYear) return {};
      const encodedLockYear = lockYear.replace('/', '-');
      const url = `/report/${reportName}/download/${rcaId}/${encodedLockYear}?format=${format}`;

      const res = await api.get(url, {
        responseType: 'arraybuffer',
      });
      return res?.data || {};
    },
  };
};
